import Markdown from 'react-native-markdown-display'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'
import type { ComponentProps } from 'react'
import { fontFamilies, mesaColorNames, typography } from '@/src/common/theme'

export function MesaMarkdown(props: ComponentProps<typeof Markdown>) {
  const defaultStyles = {
    body: { ...typography.S, color: '#FFF' },
    link: { ...typography.S, color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] },
    strong: { fontFamily: fontFamilies['PlusJakartaSans-Bold'], fontWeight: 700 },
  }

  return (
    <Markdown
      {...props}
      style={
        // Combine the default styles with custom body styles
        {
          ...defaultStyles,
          ...props.style,
          body: { ...defaultStyles.body, ...props.style?.body },
        }
      }
      onLinkPress={(...args) => {
        props.onLinkPress?.(...args)
        const [url] = args
        if (url.startsWith('mailto:')) {
          return true
        }
        void openInAppBrowser(url, 'Mesa')
        // Return false to prevent the default behavior (Linking.openURL)
        return false
      }}
    />
  )
}
